import styles from '../../styles/MenuStatic/ExportPdfAndCsv.module.css';
import { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../services/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';

const ExportPdfAndCsv = () => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);
  const [yearMonthMap, setYearMonthMap] = useState({});
  const [yearDate, setYearDate] = useState('');
  const [monthDate, setMonthDate] = useState('');
  const [format, setFormat] = useState('csv');

  const headingRef = useRef(null);

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (!user) {
      // ユーザーがログインしていない場合、ログインページにリダイレクト
      navigate('/home/login');
    }
    if (headingRef.current) {
      // ページ開いたらData Exportにフォーカスして画面を表示する
      headingRef.current.focus();
    }
  }, [user, isLoading, navigate]); // userとisLoadingが変化したときに実行される

// 年月オプションの取得
  useEffect(() => {
    axios.get(`${API_URL}/api/transactions/date-options`, {
      withCredentials: true
    })
    .then(res => {
      const data = res.data; // axiosはレスポンスデータを `.data` に持っているため、.jsonはだめ
      const map = {};
      data.forEach(({ year, month }) => {
        if (!map[year]) map[year] = new Set();
        map[year].add(month);
      });

      const convertedMap = {};
      for (const y in map) {
        convertedMap[y] = Array.from(map[y]).sort((a, b) => a - b);
      }

      setYearMonthMap(convertedMap);
      setYearOptions(Object.keys(convertedMap).sort((a, b) => b - a));
    })
    .catch(err => console.error('年月取得エラー:', err));
  }, []);

  // 年を選んだら月をリセット
  useEffect(() => {
    if (yearDate && yearMonthMap[yearDate]) {
      setMonthOptions(yearMonthMap[yearDate]);
    } else {
      setMonthOptions([]);
      setMonthDate(''); // 選ばれた月もリセット
    }
  }, [yearDate, yearMonthMap]);

  // ダウンロード処理
  const handleDownload = async () => {
    if (!yearDate || !format) {
      toast.warning('年もしくは形式の入力が必須です');
      return;
    }

    try {
      const response = await axios.get(`${API_URL}/api/transactions/export`, {
        withCredentials: true,
        params: { year: yearDate, month: monthDate, format },
        responseType: 'blob'
      });      

      const paddedMonth = monthDate ? String(monthDate).padStart(2, '0') : '';
      const fileName = `summary_${yearDate}${paddedMonth ? `_${paddedMonth}` : ''}.${format}`;
      const blob = new Blob([response.data], { type: format === 'csv' ? 'text/csv' : 'application/pdf' });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
    // localstorageからHTTPステータスで判断し、DL
      if (err.response?.status === 401 || err.response?.status === 403) {
        toast.warning("ログインが必要です");
        navigate('home/login');
        return;
      }
      toast.warning('ダウンロードに失敗しました');
    }
  };

  return (
    <main>
      <>
        <div className={styles.exportMainContainer}>
          <div className={styles.exportPdfAndCsvImage} />
          <h1 ref={headingRef} tabIndex={-1}>Data Export</h1>

          <div className={styles.select_row}>
            <label htmlFor='year'>年：</label>
            <select id='year' name='yearDate' value={yearDate} onChange={(e) => setYearDate(e.target.value)}>
              <option value="">-- 年を選択 --</option>
              {yearOptions.map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>

            <label htmlFor='month'>月：</label>
            <select id='month' name='monthDate' value={monthDate} onChange={(e) => setMonthDate(e.target.value)}>
              <option value="">-- 月を選択 --</option>
              {monthOptions.map((month) => (
                <option key={month} value={month}>{month}</option>
              ))}
            </select>

            <label htmlFor='form'>ファイル形式：</label>
            <select id='form' name='format' value={format} onChange={(e) => setFormat(e.target.value)}>
              <option value='csv'>CSV</option>
              <option value='pdf'>PDF</option>
            </select>
          </div>

          <div className={styles.btn_row}>
            <button type="button" onClick={handleDownload} className={styles.download_btn}>
            <span>ダウンロード</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none">
              <path stroke="currentColor" strokeWidth="0.8" d="m5.791 3.5 3.709 3H2"></path>
            </svg>
            </button>
          </div>
        </div>
      </>
    </main>
  );
};

export default ExportPdfAndCsv;